const isRecord = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

export const normalizeDefaultServicePrice = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (isRecord(value)) return [value];
  return [];
};

export const formatCatalogAmount = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "number" || typeof value === "string") return value;
  if (!isRecord(value)) return "";
  if (value.amount != null) return formatCatalogAmount(value.amount);
  if (value.amount_minor != null && Number.isFinite(Number(value.amount_minor))) {
    return (Number(value.amount_minor) / 100).toFixed(2);
  }
  return "";
};

export const normalizeCatalogPage = (payload) => {
  if (Array.isArray(payload)) {
    return { current_page: 1, data: payload, next_page_url: null };
  }

  if (!isRecord(payload)) return payload;

  if (Array.isArray(payload.data)) return payload;

  if (isRecord(payload.data) && payload.data.id != null) {
    return { ...payload, data: [payload.data] };
  }

  if (payload.id != null) {
    return { current_page: 1, data: [payload], next_page_url: null };
  }

  return payload;
};

export const normalizeSelectedMembership = (payload, membershipId) => {
  const normalized = normalizeCatalogPage(payload);
  const records = Array.isArray(normalized?.data) ? normalized.data : [];
  const requestedId = membershipId == null || membershipId === "" ? null : String(membershipId);

  if (!requestedId) return records.length === 1 ? records[0] : null;
  return records.find((record) => record && String(record.id) === requestedId) || null;
};

const serviceRecord = (value) => {
  if (!isRecord(value)) return null;
  if (isRecord(value.services) && value.services.id != null) return serviceRecord(value.services);

  const id = value.id ?? value.service_id;
  const name = value.name ?? value.service_name;
  if (id == null || name == null) return null;
  return { ...value, id, name };
};

const collectServices = (payload, records = []) => {
  if (Array.isArray(payload)) {
    payload.forEach((item) => collectServices(item, records));
    return records;
  }

  if (!isRecord(payload)) return records;

  if (Array.isArray(payload.services)) {
    payload.services.forEach((item) => collectServices(item, records));
  } else if (payload.service !== undefined) {
    collectServices(payload.service, records);
  } else if (payload.options !== undefined) {
    collectServices(payload.options, records);
  } else if (payload.data !== undefined) {
    collectServices(payload.data, records);
  } else {
    const record = serviceRecord(payload);
    if (record) records.push(record);
  }

  return records;
};

export const normalizeSelectedService = (payload, serviceId) => {
  const records = collectServices(payload);
  const requestedId = serviceId == null || serviceId === "" ? null : String(serviceId);

  if (requestedId) {
    return records.find((record) => String(record.id) === requestedId) || null;
  }

  return records.length === 1 ? records[0] : null;
};
